// Font dichiarati dal tema di @easydoctor/ui ma non inclusi nel pacchetto (README di
// easydoctor-io/design-system, «Come si consuma › 4. Uso»).
import '@fontsource/inter/latin-300.css';
import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import '@fontsource/jetbrains-mono/latin-400.css';
import '@fontsource/jetbrains-mono/latin-500.css';
// Stile delle barre di scorrimento di SimpleBar (sidebar della shell), come in EasyCare.
import 'simplebar-react/dist/simplebar.min.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root non trovato in index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
